import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-583c00d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "StepTimeSlots" }
const _hoisted_2 = { class: "px-6 py-4 bg-white border" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "StepTimeSlots__title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = { class: "StepTimeSlots__title" }
const _hoisted_8 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_9 = { class: "flex items-center justify-end mt-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_select = _resolveComponent("the-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.completed)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.title), 1),
              _createVNode(_component_the_button, {
                type: "button",
                class: "second small text",
                onClick: _ctx.onUpdate
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createTextVNode(" Сбросить ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              (Boolean(_ctx.modelValue))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.selectedText) + ": " + _toDisplayString(_ctx.modelValue?.timeFrom) + " - " + _toDisplayString(_ctx.modelValue?.timeTo), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.title), 1),
            (_ctx.opened)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_the_select, {
                    searchable: false,
                    value: _ctx.selectedTimeSlotId,
                    loading: _ctx.state.is_loading,
                    failed: _ctx.state.is_failed,
                    options: _ctx.state.list,
                    disabled: _ctx.disabled,
                    onChange: _ctx.onTimeSlotChange
                  }, {
                    "selected-option": _withCtx(({ option }) => [
                      _createTextVNode(_toDisplayString(option.timeFrom) + " - " + _toDisplayString(option.timeTo), 1)
                    ]),
                    option: _withCtx(({ option }) => [
                      _createTextVNode(_toDisplayString(option.timeFrom) + " - " + _toDisplayString(option.timeTo), 1)
                    ]),
                    _: 1
                  }, 8, ["value", "loading", "failed", "options", "disabled", "onChange"]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_the_button, {
                      type: "button",
                      class: "text primary small",
                      disabled: _ctx.disabled || !_ctx.modelValue,
                      onClick: _ctx.onSubmit
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10,
                        _createTextVNode(" Продолжить ")
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
    ])
  ]))
}